import Layout from "../../components/layout/Layout";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import i18n from "../../i18n";
import SeoHead from "../../components/elements/SeoHead";

const PublicOfferUk = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();

    useEffect(() => {
      const handleLanguageChange = () => {
        navigate(`/${i18n.language}/public-offer`)
      };
  
      i18n.on("languageChanged", handleLanguageChange);
      return () => {
        i18n.off("languageChanged", handleLanguageChange);
      };
    }, []);
    return (
        <Layout headerStyle={1} footerStyle={2} >
            <SeoHead metaKey="seo.publicOffer" />
            <div className="container" style={{ display: "flex", flexDirection: "column", gap: 10, marginBottom: 30 }}>
                <h2 style={{ textTransform: "none", marginBottom:20 }}>Публічний договір оферти на надання послуг з управління проектами через платформу SkTech</h2>
                <p>Цей документ є публічною офертою та публічним договором, адресованим користувачам для укладення договору про надання послуг з управління проектами через платформу SkTech (далі – «Платформа»). Користуючись Платформою та здійснюючи оплату підписки, Користувач автоматично приймає умови цього Договору.</p>

                <p>Згідно з положеннями ст. 633, 641 Цивільного кодексу України умови публічної оферти та публічного договору є однаковими для всіх користувачів. У відповідності до ч. 2 ст. 642 Цивільного кодексу України реєстрація на платформі SkTech (<a href="https://sk-tech.ai">https://sk-tech.ai</a>) є акцептом цієї оферти, що прирівнюється до укладення договору на умовах, викладених нижче, а також відповідно до Політики конфіденційності. Політика конфіденційності регулює обробку персональних даних користувачів. Ознайомитися з умовами Політики конфіденційності можна за посиланням на нашому сайті. Політика конфіденційності є невід’ємною частиною цих умов.</p>

                <h3>1. Загальні положення</h3>
                <p>1.1. Цей Договір регулює відносини між Сайтом SkTech ТОВ “САНПОІНТ АЙ-ТІ СОЛЮШНС” (далі – «Адміністрація») та користувачем (далі – «Користувач»), що укладаються на основі прийняття оферти.</p>
                <p>1.2. Цей Договір є офіційною пропозицією Адміністрації для укладення договору на умовах, викладених нижче.</p>
                <p>1.3. Використання Платформи означає повну згоду Користувача з усіма умовами Договору.</p>

                <h3>2. Предмет договору</h3>
                <p>2.1. Адміністрація надає Користувачеві доступ до платформи для управління проектами (далі – «Сервіс») на умовах підписки, а Користувач зобов’язується оплатити відповідну вартість.</p>
                <p>2.2. Доступ до Сервісу надається в обмін на оплату обраної підписки: щомісячної або річної.</p>

                <h3>3. Порядок укладення договору</h3>
                <p>3.1. Договір вважається укладеним із моменту прийняття Користувачем оферти шляхом здійснення оплати підписки на Платформі.</p>
                <p>3.2. Прийняття (акцепт) оферти означає повне та безумовне прийняття всіх умов Договору без будь-яких виключень.</p>

                <h3>4. Права та обов’язки сторін</h3>
                <ul style={{ paddingLeft: "2rem" }}>
                    <li style={{ paddingBottom: 10 }}><strong>4.1. Обов’язки Адміністрації:</strong>
                        <ul>
                            <li>Надавати доступ до платформи для управління проектами відповідно до обраної підписки;</li>
                            <li>Забезпечувати належний технічний стан Сервісу для стабільної роботи;</li>
                            <li>Відповідати на запити та вирішувати питання, що виникають під час користування Сервісом.</li>
                        </ul>
                    </li>
                    <li><strong>4.2. Обов’язки Користувача:</strong>
                        <ul>
                            <li>Дотримуватися умов цього Договору та Політики конфіденційності;</li>
                            <li>Надавати лише достовірну інформацію під час реєстрації;</li>
                            <li>Не передавати свої дані для доступу до Сервісу третім особам.</li>
                        </ul>
                    </li>
                </ul>

                <h3>5. Вартість послуг та порядок оплати</h3>
                <p>5.1. Вартість підписки публікується на Сайті в доларах США. Ціна в гривнях визначається шляхом конвертації платіжною системою за її курсом на день оплати:</p>
                <ul>
                    <li>Тариф «Базовий»: 10 доларів США на місяць або 100 доларів США на рік (еквівалент у гривнях — за курсом платіжної системи на момент оплати).</li>
                    <li>Тариф «Комфорт»: 25 доларів США на місяць або 250 доларів США на рік (еквівалент у гривнях — за курсом платіжної системи на момент оплати).</li>
                    <li>Тариф «Без меж»: 30 доларів США на місяць або 300 доларів США на рік (еквівалент у гривнях — за курсом платіжної системи на момент оплати).</li>
                </ul>
                <p>5.2. Оплата здійснюється через платіжну систему, інтегровану на Платформі, і сума буде конвертована за курсом платіжної системи на день оплати.</p>
                <p>5.3. Адміністрація залишає за собою право змінювати вартість підписки, попередньо повідомивши Користувача через Платформу.</p>

                <h3>6. Порядок повернення коштів</h3>
                <p>6.1. У разі технічних проблем із боку Адміністрації, що призвели до неможливості користування Сервісом, Користувач може звернутися із запитом на часткове або повне повернення коштів.</p>
                <p>6.2. Запит має бути поданий протягом 14 календарних днів із моменту виникнення проблеми.</p>
                <p>6.3. Повернення коштів не здійснюється, якщо Користувач добровільно припинив користування Сервісом до завершення терміну дії підписки.</p>

                <h3>7. Відповідальність сторін</h3>
                <p>7.1. Адміністрація не несе відповідальності за збитки, що виникли через:</p>
                <ul>
                    <li>Некоректне використання Сервісу Користувачем.</li>
                    <li>Проблеми в роботі обладнання або програмного забезпечення Користувача.</li>
                    <li>Форс-мажорні обставини.</li>
                </ul>
                <p>7.2. Користувач несе відповідальність за достовірність інформації, наданої під час реєстрації.</p>

                <h3>8. Термін дії договору</h3>
                <p>8.1. Договір набуває чинності з моменту оплати підписки та діє протягом обраного періоду (місяць або рік).</p>
                <p>8.2. Після завершення строку підписки Користувач може подовжити дію договору, здійснивши оплату наступного періоду.</p>

                <h3>9. Інші умови</h3>
                <p>9.1. Адміністрація має право змінювати умови Договору. Зміни набувають чинності з моменту їх публікації на Платформі.</p>
                <p>9.2. Продовження користування Сервісом після внесення змін означає згоду Користувача з такими змінами.</p>

                <h3>10. Контактна інформація</h3>
                <p>ТОВ “САНПОІНТ АЙ-ТІ СОЛЮШНС”</p>
                <p>Код ЄДРПОУ: 42783354</p>
                <p>Адреса: вул. Серпова, 11, м. Київ, Україна</p>
                <p>Email: sktech@sunpoint.com.ua</p>

                <p>Цей Договір є публічним, безстроковим, та залишається чинним до моменту його відкликання Адміністратором.</p>
            </div>

        </Layout>
    )
}
export default PublicOfferUk;